import { useEffect } from "react";
import {
  DEFAULT_OG_IMAGE,
  DEFAULT_SEO,
  SITE_NAME,
  SITE_URL,
} from "../../common";

const setMeta = (attribute, key, content) => {
  let element = document.head.querySelector(`meta[${attribute}="${key}"]`);

  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }

  element.setAttribute("content", content);
};

const setCanonical = (url) => {
  let element = document.head.querySelector('link[rel="canonical"]');

  if (!element) {
    element = document.createElement("link");
    element.setAttribute("rel", "canonical");
    document.head.appendChild(element);
  }

  element.setAttribute("href", url);
};

const setStructuredData = (id, data) => {
  let element = document.head.querySelector(`script[data-seo-id="${id}"]`);

  if (!element) {
    element = document.createElement("script");
    element.type = "application/ld+json";
    element.dataset.seoId = id;
    document.head.appendChild(element);
  }

  element.textContent = JSON.stringify(data);
};

export const Seo = ({
  title = DEFAULT_SEO.title,
  description = DEFAULT_SEO.description,
  path = DEFAULT_SEO.path,
  image = DEFAULT_OG_IMAGE,
  type = "website",
  noIndex = false,
  structuredData,
}) => {
  useEffect(() => {
    const canonicalUrl = `${SITE_URL}${path}`;
    const socialImage = image.startsWith("http")
      ? image
      : new URL(image, SITE_URL).href;

    document.title = title;
    document.documentElement.lang = "en-US";

    setMeta("name", "description", description);
    setMeta(
      "name",
      "robots",
      noIndex
        ? "noindex, nofollow"
        : "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
    );
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", type);
    setMeta("property", "og:url", canonicalUrl);
    setMeta("property", "og:image", socialImage);
    setMeta("property", "og:image:alt", `${SITE_NAME} custom kitchen project`);
    setMeta("property", "og:site_name", SITE_NAME);
    setMeta("property", "og:locale", "en_US");
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", socialImage);
    setMeta("name", "twitter:image:alt", `${SITE_NAME} custom kitchen project`);

    setCanonical(canonicalUrl);

    if (structuredData) {
      setStructuredData("page", structuredData);
    } else {
      document.head.querySelector('script[data-seo-id="page"]')?.remove();
    }
  }, [description, image, noIndex, path, structuredData, title, type]);

  return null;
};
